/**
 * Pair portrait/square images; place each landscape image in its own full-width row.
 * Odd-length portrait runs put the first image in a solo full-width row, then pair the rest.
 */
export default function buildImageRows(items, landscapeBySrc) {
  const rows = [];
  let pending = [];

  const flushPending = () => {
    if (pending.length === 0) return;

    const run = pending;
    pending = [];

    let index = 0;
    if (run.length % 2 === 1) {
      rows.push([run[0]]);
      index = 1;
    }

    for (; index < run.length; index += 2) {
      rows.push([run[index], run[index + 1]]);
    }
  };

  items.forEach(item => {
    if (landscapeBySrc[item.src]) {
      flushPending();
      rows.push([item]);
      return;
    }

    pending.push(item);
  });

  flushPending();
  return rows;
}
